export const headerConfig = {
  headerTitle: 'Applications Being Processed',
  headerDescription: 'List of Applications being processed',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
